import { IAllBotsPage } from '@gem/models/botCatalogModel';
import { ICursorRequest } from '@gem/models/commonModel';
import { IBotUserDisplayData } from '@gem/models/userModel';
import { logger } from '@gem/modules/logger';

import { buildModelError } from '../error/errorBuilder';

// Needs Bff implementation
export const getAllBots = async (data: ICursorRequest): Promise<IAllBotsPage> => {
  try {
    const response = {} as IAllBotsPage;
    return response;
  } catch (error) {
    logger.get('API').error('botsCatalog.getAllBots', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const addBotToProfile = async (botId: string): Promise<IBotUserDisplayData | null> => {
  try {
    const response = {} as IBotUserDisplayData;
    return response;
  } catch (error) {
    logger.get('API').error('botsCatalog.addBotToProfile', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const removeBotFromProfile = async (botId: string): Promise<IBotUserDisplayData> => {
  try {
    const response = {} as IBotUserDisplayData;
    return response;
  } catch (error) {
    logger.get('API').error('botsCatalog.addBotToProfile', error);
    throw buildModelError(error);
  }
};
